import React from "react";

function ShippingPolicy() {
  return (
    <div className="privacy-policy">
      <div className="privacy-policy-in">
        <h1>Shipping Policy</h1>

        <h2>THIS SHIPPING POLICY IS ONLY FOR INDIA ORDER.</h2>

        <h2>Processing Time</h2>
        <p>
          100% of orders are shipped from our warehouse within 1-2 business
          days. Orders placed over the weekend are dispatched on Mondays.
        </p>

        <h2>Shipping Time</h2>
        <p>
          <strong>Fast Shipping (Gujarat):</strong> Delivery in 3-4 business
          days after dispatch.
        </p>
        <p>
          <strong>Fast Shipping (All Other States):</strong> Delivery in 4-6
          business days after dispatch.
        </p>
        <p>
          <strong>Flat Shipping (Gujarat):</strong> Delivery in 5-6 business
          days after dispatch.
        </p>
        <p>
          <strong>Flat Shipping (All Other States):</strong> Delivery in 6-8
          business days after dispatch.
        </p>

        <h2>Order Tracking</h2>
        <p>
          Once your order has been shipped, we will email you a tracking number
          and a link to the courier’s website. If you do not receive this email,
          please contact our customer service team. You can also track your
          order by calling our order helpline at +91 9638666602 or emailing
          care@deodap.com.
        </p>

        <h2>Delivery Costs</h2>
        <p>
          Delivery charges depend on your location. Please check your order
          summary to understand the delivery charges for individual products.
        </p>

        <h2>Failed Delivery</h2>
        <p>
          If the package cannot be delivered due to incorrect shipping details
          or absent receiver, or if the package is refused, it will be returned
          to the sender at the customer’s expense. The expense includes shipping
          costs, which will be deducted from the total refund amount.
        </p>

        <h2>Our Carriers</h2>
        <p>
          We use DTDC, Shree Mahavir Express, Delhivery, India Post, Xpressbees,
          Shree Mahabali Express, and Ecom Express for deliveries.
        </p>

        <h2>Upon Receipt of Your Order</h2>
        <p>
          Inspect the package and goods carefully before signing for delivery.
          If the parcel is damaged or incomplete, refuse delivery or sign
          "Damaged" and contact us on the day of delivery.
        </p>

        <h2>Bank Holidays</h2>
        <p>
          We do not deliver on bank holidays. Your parcel will be delivered on
          the next working day.
        </p>

        <h2>9. Contact Us</h2>
        <p>
          If you have any questions or concerns about this Privacy Policy,
          please contact us at:
        </p>
        <p>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
    <p>Name: CGTHomes </p>
    <p>Email: info@cgthomes.com</p>
    <p>Company Email: support@cgthomes.com</p>
    <p>Company Address: Street No 3, DLF Cyber City Hyderabad, telengana</p>
      </div>
    </div>
  );
}

export default ShippingPolicy;
